import { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import clientOnly from '../decorators/client-only';
import { removeLeadingSlash, removeTrailingSlash } from '../utils/string';
import { createUrl, getPath } from '../utils/url';
import { trackPageView as trackPageViewAction } from '../actions/tracking';

const mapStateToProps = ({
  documentIndex,
  location: { baseURL }
}) => ({
  documentIndex,
  baseURL
});
const mapDispatchToProps = {
  trackPageView: trackPageViewAction
};

const getDocumentIdentifer = pathname => removeLeadingSlash(removeTrailingSlash(pathname)) || null;

const getDocumentId = (location, documentIndex) => {
  const identifier = getDocumentIdentifer(location.pathname);
  return identifier && documentIndex[identifier] && documentIndex[identifier].id
    ? documentIndex[identifier].id
    : false;
};

const getSearchQuery = location =>
  (location.search && location.search.length ? location.search.replace('?query=', '') : false);

const track = ({
  location, trackPageView, documentIndex, baseURL
}) => {
  const documentId = getDocumentId(location, documentIndex);
  const pageViewLabel = documentId ? 'DocumentPageview' : 'SearchPageview';
  const properties = documentId ? { documentId } : { searchQuery: getSearchQuery(location) || '' };
  const path = getPath(createUrl(baseURL, location));

  return trackPageView(path, pageViewLabel, properties);
};

class PageView extends Component {
  componentDidMount() {
    track(this.props);
  }

  shouldComponentUpdate({ baseURL, location }) {
    return getPath(createUrl(baseURL, location))
      !== getPath(createUrl(baseURL, this.props.location));
  }

  componentDidUpdate() {
    track(this.props);
  }

  render() {
    return null;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(clientOnly(PageView)));



// WEBPACK FOOTER //
// ./src/universal/ui/components/PageView.js